export const EyeOffIcon = ({ className, size = 20, color = "#212529", ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      // The artwork is drawn in a fixed 20x20 coordinate space, so the viewBox
      // stays 20x20 and `size` only scales it. Deriving the viewBox from `size`
      // instead crops the icon at any size other than 20.
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_12923_3662)">
        <path
          d="M2.82373 2.05957C3.27838 1.54031 4.06796 1.48787 4.5874 1.94238L7.13818 4.1748C8.04383 3.89961 9.00477 3.75 10.0005 3.75C14.1668 3.75013 17.7248 6.34201 19.1665 10C18.7213 11.1298 18.0736 12.1576 17.269 13.0391L18.7056 14.2959C19.2247 14.7505 19.2779 15.5401 18.8237 16.0596C18.3693 16.5789 17.5796 16.6318 17.0601 16.1777L15.3403 14.6729C13.8021 15.6697 11.9698 16.2499 10.0005 16.25C5.83382 16.25 2.27516 13.6583 0.833496 10C1.59376 8.07099 2.94253 6.4384 4.65869 5.32617L2.94092 3.82324C2.42148 3.36862 2.36916 2.57908 2.82373 2.05957ZM6.86572 7.25684C6.22346 7.9899 5.8336 8.94957 5.8335 10C5.8335 12.3 7.70049 14.167 10.0005 14.167C11.2499 14.1669 12.3704 13.6152 13.1343 12.7432L11.8804 11.6455C11.4226 12.1685 10.7521 12.4999 10.0005 12.5C8.61716 12.5 7.50049 11.3833 7.50049 10C7.50059 9.36864 7.73416 8.79389 8.11865 8.35449L6.86572 7.25684ZM10.0005 5.83398C9.70436 5.83398 9.41494 5.86402 9.13623 5.92285L11.5864 8.06641C11.5939 8.07254 11.6005 8.07972 11.6079 8.08594L14.1538 10.3125C14.1615 10.2094 14.1665 10.105 14.1665 10C14.1663 7.7003 12.3002 5.83416 10.0005 5.83398Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_12923_3662">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
